
  var _styles = {
  "coupon-usage-record__container": {
    "width": "10rem",
    "height": "14.6rem",
    "display": "flex",
    "flexDirection": "column",
    "justifyContent": "space-between",
    "alignItems": "center",
    "paddingTop": "0.48rem",
    "paddingRight": "0.42667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.42667rem",
    "borderRadius": "0.42667rem 0.42667rem 0 0",
    "background": "#f8f8f8"
  },
  "coupon-usage-record__empty-content": {
    "paddingTop": "1.93333rem",
    "alignItems": "center"
  },
  "coupon-usage-record__empty-text": {
    "color": "rgb(255,75,16)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem",
    "lineHeight": "24px",
    "WebkitTextDecoration": "NONE",
    "textDecoration": "NONE",
    "position": "relative",
    "top": "-0.77333rem",
    "opacity": 0.7
  },
  "coupon-usage-record__scroll-view": {
    "height": "14.6rem",
    "flex": 1
  },
  "coupon-usage-record__content": {
    "alignItems": "center"
  },
  "tab-container": {
    "width": "9.04rem",
    "height": "0.50667rem",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "space-between",
    "marginBottom": "0.48rem",
    "marginLeft": "0.05333rem",
    "marginRight": "0.05333rem"
  },
  "tab-item": {
    "alignItems": "center",
    "justifyContent": "space-between"
  },
  "tab-text": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500"
  },
  "tab-text-append": {
    "marginLeft": "0.10667rem"
  },
  "tab-line": {
    "width": "0.53333rem",
    "height": "0.10667rem",
    "borderRadius": "0.26667rem"
  },
  "coupon-list-title": {
    "position": "relative",
    "top": 0
  },
  "coupon-usage-item-wrap": {
    "width": "9.14667rem",
    "height": "2.02667rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "marginBottom": "0.21333rem",
    "borderRadius": "0.21333rem"
  },
  "coupon-usage-item-left": {
    "marginTop": 0,
    "marginRight": "0.05333rem",
    "marginBottom": 0,
    "marginLeft": "0.05333rem",
    "width": "2.37333rem"
  },
  "coupon-usage-item-price": {
    "width": "100%",
    "height": "0.69333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "justifyContent": "center",
    "fontFamily": "MTNewDigitalDisplay-Regular",
    "fontWeight": "700"
  },
  "coupon-usage-item-price-symbol": {
    "height": "0.45333rem",
    "color": "rgb(255,75,16)",
    "fontSize": "0.42667rem",
    "fontWeight": "700",
    "fontFamily": "MTNewDigitalDisplay-Regular"
  },
  "coupon-usage-item-price-symbol2": {
    "height": "0.45333rem",
    "color": "rgb(255,75,16)",
    "fontSize": "0.4rem",
    "fontWeight": "700",
    "fontFamily": "MTNewDigitalDisplay-Regular"
  },
  "coupon-usage-item-price-value": {
    "fontFamily": "MTNewDigitalDisplay-Regular",
    "height": "0.85333rem",
    "color": "rgb(255,75,16)",
    "fontSize": "0.8rem",
    "fontWeight": "700"
  },
  "coupon-usage-item-condition": {
    "width": "100%",
    "height": "0.37333rem",
    "marginTop": "0.18667rem",
    "marginBottom": "0.05333rem",
    "fontWeight": "400",
    "color": "rgb(255,75,16)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.37333rem",
    "textAlign": "center"
  },
  "coupon-usage-item-mid": {
    "width": "4.64rem",
    "alignItems": "flex-start"
  },
  "coupon-usage-item-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "0.48rem",
    "marginTop": "0.16rem"
  },
  "coupon-usage-item-period": {
    "height": "0.42667rem",
    "marginTop": "0.24rem",
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.37333rem"
  },
  "coupon-usage-item-limit": {
    "fontWeight": "400",
    "color": "rgb(255,75,16)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "height": "0.34667rem",
    "marginTop": "0.33333rem",
    "lineHeight": "0.34667rem"
  },
  "coupon-usage-item-right": {
    "marginRight": "0.32rem",
    "width": "1.76rem",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.8rem"
  },
  "coupon-usage-item-status": {
    "width": "100%",
    "color": "rgb(255,75,16)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.37333rem",
    "height": "0.8rem",
    "lineHeight": "0.8rem",
    "textAlign": "center",
    "justifyContent": "center",
    "alignItems": "center",
    "borderWidth": "0.01333rem",
    "borderStyle": "solid",
    "borderRadius": "0.4rem"
  }
};



  module.exports = _styles;
  